import {
  BrandKitField,
  BrandKitFieldType,
  BrandKitListItemType,
} from './brand-kit-field';

/** Fields a new brand kit's first draft starts with. */
export const DefaultBrandKitFields: readonly BrandKitField[] = [
  {
    key: 'primary_color',
    label: 'Primary color',
    type: BrandKitFieldType.Color,
    description:
      'The main brand color. Use for primary calls to action, key headings, and brand moments.',
  },
  {
    key: 'secondary_color',
    label: 'Secondary color',
    type: BrandKitFieldType.Color,
    description:
      'Supports the primary color. Use for secondary actions, accents, and highlights.',
  },
  {
    key: 'neutral_palette',
    label: 'Neutral palette',
    type: BrandKitFieldType.List,
    itemType: BrandKitListItemType.Color,
    description:
      'Approved grays and neutrals, lightest to darkest. Use for text, backgrounds, borders, and dividers.',
    value: [],
  },
  {
    key: 'heading_font',
    label: 'Heading font',
    type: BrandKitFieldType.Font,
    description: 'Typeface for headlines and display text.',
  },
  {
    key: 'body_font',
    label: 'Body font',
    type: BrandKitFieldType.Font,
    description: 'Typeface for body copy, UI text, and captions.',
  },
  {
    key: 'tagline',
    label: 'Tagline',
    type: BrandKitFieldType.Text,
    description: 'The brand tagline, used verbatim.',
    value: '',
  },
  {
    key: 'voice',
    label: 'Voice and tone',
    type: BrandKitFieldType.LongText,
    description:
      'How the brand sounds in writing: personality, tone, vocabulary to favor or avoid.',
    value: '',
  },
  {
    key: 'audience',
    label: 'Audience',
    type: BrandKitFieldType.LongText,
    description: 'Who the brand speaks to and what they care about.',
    value: '',
  },
  {
    key: 'rules',
    label: 'Rules',
    type: BrandKitFieldType.List,
    itemType: BrandKitListItemType.Text,
    description:
      'Hard constraints every piece of content must follow, e.g. "never place the logo on a busy background".',
    value: [],
  },
  {
    key: 'website',
    label: 'Website',
    type: BrandKitFieldType.Url,
    description: 'The brand website, for reference on current look and feel.',
  },
];
